import React from 'react'
import cn from 'classnames'
import styles from './right-sidebar.module.scss'
import Sidebar from 'components/shared/Sidebar/Sidebar'
import useStore, { resolveEffectiveTheme } from 'state/knovStore'
import FilterOptions from 'components/filters/FilterOptions'
import WalletHistory from 'components/wallet/WalletHistory'
import { isMobile } from 'lib/device'
import UpvalueLeaderboardWidget from 'components/leaderboards/UpvalueLeaderboardWidget'
import type { User } from 'types/users'

interface RightSidebarProps {
    show: boolean
    onClose: () => void
    user?: User
}

export default function RightSidebar({ show, onClose, user }: RightSidebarProps) {
    const numPanels = useStore(state => state.numPanels)
    const onePanel = numPanels === 1
    const theme = useStore(state => state.appearanceTheme)
    const effectiveTheme = resolveEffectiveTheme(theme)
    const isMobileDevice = isMobile
    const sidebarTheme = isMobileDevice ? `mobile-${effectiveTheme}` : effectiveTheme

    return (
        <Sidebar
            show={show}
            onClose={onClose}
            containerClassName={styles.rightSidebar}
            openClassName={styles.show}
            contentClassName={styles.content}
            mobileContentClassName={styles.mobileContent}
            contentProps={
                { 'data-sidebar-theme': sidebarTheme } as React.HTMLAttributes<HTMLDivElement>
            }
            overlayProps={{ onClick: onClose }}
        >
            <FilterOptions
                user={user}
                header="User"
                show={['profile', 'wallet', 'account-ordinals', 'settings', 'metrics', 'admin']}
                theme={effectiveTheme}
                contextStyles={cn(styles.rightSidebarFilterOptions)}
                selectedStyle={onePanel ? styles.onePanelSelected : styles.selected}
                hoverStyle={onePanel ? styles.onePanelHover : styles.hover}
                close={onClose}
                append={true}
            />

            {show && (
                <div className={styles.leadersContainer}>
                    <UpvalueLeaderboardWidget onClose={onClose} />
                </div>
            )}

            <WalletHistory />
        </Sidebar>
    )
}
